import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    height: '100%',
  },
});
